import React, { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { LockKey, SignOut } from '@phosphor-icons/react';

export const ForcePasswordChange = () => {
  const { api, checkAuth, logout, user } = useAuth();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (next !== confirm) { setError('New passwords do not match'); return; }
    setSaving(true);
    try {
      await api.post('/auth/change-password', { current_password: current, new_password: next });
      await checkAuth();
    } catch (err) {
      setError(err?.response?.data?.detail || 'Could not change password');
    }
    setSaving(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: '#0A0A0A' }} data-testid="force-password-change">
      <div className="w-full max-w-md border rounded-3xl p-8" style={{ background: '#141414', borderColor: 'rgba(255,255,255,0.1)' }}>
        <div className="w-14 h-14 rounded-2xl bg-[#FF6B35]/15 flex items-center justify-center mb-5">
          <LockKey size={28} className="text-[#FF6B35]" />
        </div>
        <h1 className="text-2xl font-bold" style={{ color: '#fff' }}>Set your own password</h1>
        <p className="text-sm mt-2 mb-6" style={{ color: '#a3a3a3' }}>
          Welcome{user?.name ? `, ${user.name}` : ''}! You're using a temporary password — choose your own to start using HomeCommand.
        </p>
        <form onSubmit={submit} className="space-y-3">
          <input type="password" value={current} onChange={e => setCurrent(e.target.value)} required
            placeholder="Temporary password (the one you just used)" data-testid="force-current-input" autoComplete="current-password"
            style={{ background: 'rgba(255,255,255,0.05)', borderColor: 'rgba(255,255,255,0.1)', color: '#fff' }}
            className="w-full px-4 py-3 rounded-xl border text-sm outline-none focus:border-[#FF6B35]/50" />
          <input type="password" value={next} onChange={e => setNext(e.target.value)} required minLength={8}
            placeholder="New password (min 8 characters)" data-testid="force-new-input" autoComplete="new-password"
            style={{ background: 'rgba(255,255,255,0.05)', borderColor: 'rgba(255,255,255,0.1)', color: '#fff' }}
            className="w-full px-4 py-3 rounded-xl border text-sm outline-none focus:border-[#FF6B35]/50" />
          <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required minLength={8}
            placeholder="Confirm new password" data-testid="force-confirm-input" autoComplete="new-password"
            style={{ background: 'rgba(255,255,255,0.05)', borderColor: 'rgba(255,255,255,0.1)', color: '#fff' }}
            className="w-full px-4 py-3 rounded-xl border text-sm outline-none focus:border-[#FF6B35]/50" />
          {error && <p className="text-sm text-red-400 bg-red-400/10 px-4 py-2 rounded-xl" data-testid="force-error">{error}</p>}
          <button type="submit" disabled={saving} data-testid="force-submit-btn"
            style={{ color: '#fff' }}
            className="w-full py-3.5 rounded-full bg-[#FF6B35] font-semibold text-sm btn-glow disabled:opacity-50">
            {saving ? 'Saving…' : 'Set Password & Continue'}
          </button>
        </form>
        <button onClick={logout} data-testid="force-logout-btn"
          className="w-full mt-3 py-2 text-sm text-neutral-500 hover:text-neutral-300 flex items-center justify-center gap-2">
          <SignOut size={14} /> Log out
        </button>
      </div>
    </div>
  );
};
